const getStyles = (theme) =>({
  step:{
    paddingTop: "5%",
  },
});

export default getStyles;
